package com.shadowings.gero.presentation.component.quiz

import androidx.compose.runtime.Composable
import com.shadowings.gero.domain.model.QuizText
import org.jetbrains.compose.resources.stringResource

@Composable
fun QuizText.resolve(): String = when (this) {
    is QuizText.Resource -> if (args.isEmpty()) {
        stringResource(resource)
    } else {
        stringResource(resource, *args.toTypedArray())
    }
    is QuizText.Plain -> text
}
